import { render, staticRenderFns } from "./item-work.vue?vue&type=template&id=0034e75a&scoped=true&"
import script from "./item-work.vue?vue&type=script&lang=js&"
export * from "./item-work.vue?vue&type=script&lang=js&"
import style0 from "./item-work.vue?vue&type=style&index=0&id=0034e75a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0034e75a",
  null
  
)

export default component.exports